/**
 * Validates is supplied string is valid JSON. Caveats that
 */
export function isJSON(jsonString: string): boolean {
	try {
		const o = JSON.parse(jsonString);

		if (o && typeof o === 'object') {
			return true;
		}
	} catch (e) {}

	return false;
}
